/**
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getBaseALLData(id) { //查看参与情况总览
        return request(api.operate.FISSION + '/getJoinCondition?fissionId=' + id, METHOD.GET);
    },
    async getBaseDayData(id) { //营销裂变参与情况每天列表
        return request(api.operate.FISSION + '/getDayJoinConditionList?fissionId=' + id, METHOD.GET);
    },
    // async getStaffData() { //营销裂变员工情况列表
    //     return request(api.operate.FISSION + '/queryStaffFissionCondition', METHOD.GET);
    // },
    // async getCustomerData() { //营销裂变查看客户情况列表
    //     return request(api.operate.FISSION + '/queryCustFissionCondition', METHOD.GET);
    // },
}
export default {dataApi}